<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesPrdShiftHandoverResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="left-header">
                                    <b-button-group>
                                        <em-button
                                            type="gotoChild"
                                            custom-icon="fa fa-circle"
                                            class="btn btn-outline-primary btn-sm"
                                            :disabled="$_notChecked"
                                            show-name custom-label="接收"
                                            confirm-text="是否确认接收？"
                                            @click="receiveBatch">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author liang gang qiang
// Date 2021-10-20 16:35:51

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "mintalMesPrdShiftHandoverListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return{
            loading: false
        }
    },
    methods: {
        receiveBatch() {
            if (!this.$_notChecked) {
                this.loading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_MINTALMES_PRD_URL + "/mintalMesPrdShiftHandover/receiveBatch?ids=" + this.selectIds,
                }).then(() => {
                    this.$message.success("Operation success");
                    this.$refs.emListFilter.doQuery();
                }).finally(() => this.loading = false)
            }
        }
    }
};
</script>